import React from "react";
import loadable from "@loadable/component";
import { setDashboardData } from '../../actions/dashboard'

export default {
	component: loadable(() => import(/* webpackChunkName: "dashboard" */ "./Dashboard"),{
		fallback: <div>Loading...</div>
	}),
	clientData : async (store,match, location, matchedRoute) => {
		console.log(222)
		const modelName = match.params.modelName;
		return store.dispatch(setDashboardData({
			search : location.search,
			modelName
		}));
	}
};
